module.exports = __webpack_public_path__ + "img/box_pro_seven_1.a24589ce.jpg";